import Mailgun from 'mailgun.js';
import FormData from 'form-data';
import { marked } from 'marked';
import { getTitleFromSummary } from '../utils/stringManipulate';

const MAILGUN_API_KEY = import.meta.env.VITE_MAILGUN_API_KEY;

async function sendEmail(summaryData, receiverEmails) {
    const subject = getTitleFromSummary(summaryData.transcript);
    const content = marked(summaryData.transcript);
    const formattedEmails = receiverEmails.map(item => `<${item.value}>`);

    const mailgun = new Mailgun(FormData);
    const mg = mailgun.client({
      username: "api",
      key: MAILGUN_API_KEY || "API_KEY",
    });
    try {
      const data = await mg.messages.create("notifications.dhiraj.xyz", {
        from: "AI Summary <no-reply@notifications.dhiraj.xyz>",
        to: formattedEmails,
        subject: subject,
        text: "You have just received an email from AI Summary",
        html: content,
      });
    } catch (error) {
        // Add some sort of error notif
    }
}

export default sendEmail;